import { render, staticRenderFns } from "./GeneralSelect.vue?vue&type=template&id=2d3e7e55&"
import script from "./GeneralSelect.vue?vue&type=script&lang=js&"
export * from "./GeneralSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports